<template>
  <div>
    <div class="title-box">
      <p class="title">店铺数据</p>
      <span>任选其中两个展示</span>
    </div>
    <div class="show-shop-info">
      <p class="shop-info-title"><span>*</span> 展示信息</p>
      <ul class="shop-info-list">
        <li
          class="shop-info-li"
          v-for="(item, index) in stateList"
          :key="index"
        >
          <el-checkbox
            :label="item.name"
            :checked="item.checked"
            :disabled="!item.checked && checkedCount == 2"
            @change="changeShopShowInfo(index, item.id)"
          ></el-checkbox>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebMAsideState",

  data() {
    return {
      stateList: [
        {
          id: 1081,
          name: "浏览量",
          checked: false,
          type: "documentTotalPv",
        },
        {
          id: 1082,
          name: "下载量",
          checked: false,
          type: "documentTotalDownload",
        },
        {
          id: 1083,
          name: "文章量",
          checked: false,
          type: "articleCount",
        },
        {
          id: 1084,
          name: "视频量",
          checked: false,
          type: "videoCount",
        },
        {
          id: 1085,
          name: "资料量",
          checked: false,
          type: "documentCount",
        },
        {
          id: 1086,
          name: "专辑量",
          checked: false,
          type: "albumCount",
        },
      ], // 可选择显示的店铺数据
      checkedList: [],
    };
  },
  computed: {
    checkedCount() {
      return this.stateList.filter((item) => item.checked == true).length;
    },
    shopState() {
      return this.$store.state.mDecoration.shopState;
    },
  },
  watch: {
    shopState: {
      handler(newValue) {
        // 设置当前选中的数据
        this.checkedList = [...newValue];
        // 设置各个选项的选中状态
        newValue.forEach((item) => {
          const index = this.stateList.findIndex(
            (item2) => item2.id == item.id
          );
          this.$set(this.stateList[index], "checked", true);
        });
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {},

  methods: {
    changeShopShowInfo(index, id) {
      this.stateList[index].checked = !this.stateList[index].checked;
      if (this.stateList[index].checked) {
        this.checkedList.push(this.stateList[index]);
      } else {
        this.checkedList = this.checkedList.filter((item) => item.id != id);
      }
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setShopState", this.checkedList);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0px 0 20px;
  .title {
    color: #606266;
    font-size: 15px;
    font-style: normal;
    line-height: 15px;
    margin-right: 20px;
    transform: translateX(8px);
  }
  & > span {
    color: #c4c8d0;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
}
.show-shop-info {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .shop-info-title {
    width: 70px;
    margin-right: 12px;
    font-size: 12px;
    color: #606266;

    span {
      width: 8px;
      font-weight: 600;
      font-size: 12px;
      color: #fe4509;
    }
  }
  .shop-info-list {
    width: 230px;
    overflow: hidden;

    .shop-info-li {
      float: left;
      width: 75px;
      margin-bottom: 10px;

      ::v-deep .el-checkbox__label {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
